// Robust Markdown Parser for Blog Content
class MarkdownParser {
    constructor() {
        // Code block regex - captures language and code
        this.codeBlockRegex = /```(\w*)\s*([\s\S]*?)```/g;
    }

    // Main parse function
    parse(content) {
        console.log('🚀 MARKDOWN PARSER STARTED');
        console.log('📥 Input content:', content);
        
        if (!content || typeof content !== 'string') {
            console.log('❌ Invalid input');
            return '';
        }

        let result = content;
        
        // Step 1: Find and replace ALL code blocks
        result = this.replaceCodeBlocks(result);
        
        // Step 2: ALWAYS process hashtag headings, regardless of HTML presence
        result = this.processHashtagHeadings(result);
        
        // Step 3: Process other patterns (only if no HTML present)
        if (!result.includes('<h') && !result.includes('<p')) {
            result = this.processOtherPatterns(result);
        }
        
        console.log('✅ FINAL OUTPUT:', result);
        return result;
    }

    // Replace code blocks with proper HTML
    replaceCodeBlocks(text) {
        console.log('🔧 REPLACING CODE BLOCKS');
        console.log('🔍 Looking for ``` patterns...');
        
        // Check if there are any code blocks
        const hasCodeBlocks = text.includes('```');
        console.log('📊 Contains ```: ', hasCodeBlocks);
        
        if (!hasCodeBlocks) {
            console.log('⚠️ No code blocks found');
            return text;
        }

        // Replace each code block
        let result = text.replace(this.codeBlockRegex, (match, language, code) => {
            console.log('💻 CODE BLOCK MATCH:');
            console.log('   Full match:', match);
            console.log('   Language:', language || '(none)');
            console.log('   Code:', code ? code.substring(0, 100) + '...' : '(empty)');
            
            const lang = language || 'text';
            const cleanCode = (code || '').trim();
            
            // Build the HTML structure
            const html = this.buildCodeBlockHTML(lang, cleanCode);
            console.log('✅ Generated HTML length:', html.length);
            
            return html;
        });

        console.log('🎯 Code blocks replaced');
        return result;
    }

    // Build the code block HTML structure
    buildCodeBlockHTML(language, code) {
        const langUpper = language.toUpperCase();
        const escapedCode = this.escapeHtml(code);
        
        // Create HTML with the header INSIDE the code-block div
        return `<div class="code-block"><div class="code-header"><span class="code-language">${langUpper}</span><button class="copy-code-btn" onclick="window.copyCodeToClipboard(this)"><i class="fas fa-copy"></i> Copy</button></div><pre><code class="language-${language}">${escapedCode}</code></pre></div>`;
    }

    // Process hashtag headings specifically (always runs)
    processHashtagHeadings(text) {
        console.log('🔧 PROCESSING HASHTAG HEADINGS');
        let result = text;
        
        // Check if there are any hashtag headings first
        const hasHashtags = /^#{1,4}\s+.+$/m.test(result);
        console.log('🔍 Found hashtag headings:', hasHashtags);
        
        if (!hasHashtags) {
            console.log('⚠️ No hashtag headings found, skipping...');
            return result;
        }
        
        // Process markdown headings: #### ### ## #
        // Process from most specific (####) to least specific (#) to avoid conflicts
        console.log('🔄 Converting hashtag headings to HTML...');
        
        // Split content into lines for better processing
        const lines = result.split('\n');
        const processedLines = lines.map(line => {
            // Match hashtag headings at the start of a line
            if (/^####\s+(.+)$/.test(line)) {
                const match = line.match(/^####\s+(.+)$/);
                console.log('✅ Converting #### to h4:', match[1]);
                return `<h4>${match[1]}</h4>`;
            } else if (/^###\s+(.+)$/.test(line)) {
                const match = line.match(/^###\s+(.+)$/);
                console.log('✅ Converting ### to h3:', match[1]);
                return `<h3>${match[1]}</h3>`;
            } else if (/^##\s+(.+)$/.test(line)) {
                const match = line.match(/^##\s+(.+)$/);
                console.log('✅ Converting ## to h2:', match[1]);
                return `<h2>${match[1]}</h2>`;
            } else if (/^#\s+(.+)$/.test(line)) {
                const match = line.match(/^#\s+(.+)$/);
                console.log('✅ Converting # to h1:', match[1]);
                return `<h1>${match[1]}</h1>`;
            }
            return line;
        });
        
        result = processedLines.join('\n');
        console.log('✅ Hashtag heading processing completed');
        return result;
    }

    // Process other markdown patterns
    processOtherPatterns(text) {
        console.log('🔧 PROCESSING OTHER PATTERNS');
        let result = text;
        
        // Process bullets: - item
        result = result.replace(/^- (.+)$/gm, '<li class="custom-bullet-item">$1</li>');
        
        // Wrap consecutive bullet items in ul
        result = result.replace(/(<li class="custom-bullet-item">.*<\/li>\s*)+/g, (match) => {
            return `<ul class="custom-bullet-list">${match}</ul>`;
        });
        
        // Process headings: text:
        result = result.replace(/^([^:\n<]+):(\s*)$/gm, '<div class="custom-heading">$1:</div>');
        
        // NOTE: Bold text (**text**) is now handled by simpleHashtagFix.js
        // Removed from here to avoid conflicts
        
        console.log('✅ Pattern processing completed');
        return result;
    }

    // Escape HTML characters
    escapeHtml(text) {
        if (!text) return '';
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
        return text.replace(/[&<>"']/g, (m) => map[m]);
    }
}

// Global copy function
window.copyCodeToClipboard = function(button) {
    console.log('📋 Copy button clicked');
    
    try {
        const codeBlock = button.closest('.code-block');
        const codeElement = codeBlock.querySelector('code');
        const code = codeElement.textContent;
        
        navigator.clipboard.writeText(code).then(() => {
            button.innerHTML = '<i class="fas fa-check"></i> Copied!';
            button.style.background = '#48bb78';
            
            setTimeout(() => {
                button.innerHTML = '<i class="fas fa-copy"></i> Copy';
                button.style.background = '';
            }, 2000);
        }).catch(() => {
            // Fallback
            const textArea = document.createElement('textarea');
            textArea.value = code;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            
            button.innerHTML = '<i class="fas fa-check"></i> Copied!';
            setTimeout(() => {
                button.innerHTML = '<i class="fas fa-copy"></i> Copy';
            }, 2000);
        });
    } catch (error) {
        console.error('Copy error:', error);
    }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default new MarkdownParser();